// --------------------- Import Globais ---------------------
import { useEffect, useState } from "react";
// --------------------- Import Antd-Design ---------------------
import { Form, Input, Modal, DatePicker, Skeleton, Select } from "antd";
// --------------------- Import Hooks ---------------------
import { useExcluirAnuncio } from "../hooks/useExcluirAnuncio";
// --------------------- Import Styles ---------------------
import { Title } from "../../ViewGerenciarPostagens/styles";
// --------------------- Import Uteis ---------------------
import { useMessage } from "../../../uteis/mensagens/useMessage";
// --------------------- Import Interface ---------------------
import { ModalAnuncioProps } from "../interface/ModalAnuncio";
import { useAdicionarAnuncio } from "../hooks/useAdicionarAnuncio";

// --------------------- Import dayJS ---------------------
import dayjs from "dayjs";
import "dayjs/locale/pt-br"; // Caso queira suportar o formato em português
import customParseFormat from "dayjs/plugin/customParseFormat";
import { formStyle, layout } from "../styles";
import { useBuscarCotasDisponiveis } from "../hooks/useBuscarCotasDisponiveis";

export default function ModalAdicionar({
  isModalOpen,
  handleFechar,
  anuncioId,
  buscar,
}: ModalAnuncioProps) {
  const [formAnuncio] = Form.useForm();
  // Chamada da função para cadastrar
  const {
    cadastrar,
    isLoading: isLoadingCadastrar,
    error,
    success,
    resetSuccess,
    resetError,
  } = useAdicionarAnuncio();

  const { isLoading: isLoadingBuscar, cotas } = useBuscarCotasDisponiveis();

  // Mensagens
  const { showSuccess, showError, contextHolder } = useMessage();

  // Estado para controlar se o erro já foi exibido
  const [errorDisplayed, setErrorDisplayed] = useState(false);

  // Estado para controlar se o sucesso já foi exibido
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  // Estado inicial de dos dados Anúncio que serão cadastrados
  const [anuncioData, setAnuncioData] = useState<any>({});

  // Função que armazena os dados alterados de Anúncio
  const anuncioChange = (changedValues: Partial<any>, allValues: any) => {
    setAnuncioData(allValues);
  };

  useEffect(() => {
    if (isModalOpen && success && !successDisplayed) {
      // Mensagem de sucesso
      const msgSuccess = "Anúncio adicionado com sucesso!";
      showSuccess(msgSuccess);
      setSuccessDisplayed(true);

      // Limpa sucesso após 3 segundos
      setTimeout(() => {
        resetSuccess();
        handleFechar();
        buscar();
      }, 2000);
    }

    if (isModalOpen && error && !errorDisplayed) {
      // Mensagem de erro
      let msgError =
        "Não foi possível cadastrar este anúncio, por favor tente novamente!";
      showError(msgError);
      setErrorDisplayed(true);

      // Limpa erro após 3 segundos
      setTimeout(() => {
        setErrorDisplayed(false);
        resetError();
      }, 3000);
    }

    // Reset quando o modal fecha
    if (!isModalOpen) {
      setSuccessDisplayed(false);
      setErrorDisplayed(false);
    }
  }, [
    isModalOpen,
    success,
    error,
    showSuccess,
    resetSuccess,
    showError,
    successDisplayed,
    errorDisplayed,
    resetError,
  ]);

  return (
    <>
      <Modal
        open={isModalOpen}
        onCancel={handleFechar}
        cancelText="Cancelar"
        okText="Adicionar"
        onOk={() => cadastrar(anuncioData)}
        confirmLoading={isLoadingCadastrar}
        width={1000}
        okButtonProps={{
          style: {
            backgroundColor: "#003644",
            borderColor: "#003644",
            color: "white",
          }, // Botão "Ativar" com fundo verde
        }}
        cancelButtonProps={{
          style: {
            backgroundColor: "#f44336",
            borderColor: "#f44336",
            color: "white",
          }, // Botão "Cancelar" com fundo vermelho
        }}
      >
        {isLoadingBuscar ? (
          <Skeleton />
        ) : (
          <>
            <>{contextHolder}</>
            <Form
              {...layout}
              form={formAnuncio}
              onValuesChange={(changedValues, allValues) =>
                anuncioChange(changedValues, allValues)
              }
              name="anuncio"
              style={formStyle}
            >
              <Title>Adicionar Anúncio</Title>

              <Form.Item
                name="cotasUsuariosId"
                label="Cota Usuário"
                className="formItems"
              >
                <Select placeholder="Selecione uma cota">
                  {cotas?.map((cota) => (
                    <Select.Option key={cota.id} value={cota.id}>
                      {`${cota.proprietario} ${cota.empreendimento} - Nº Cota: ${cota.numeroCota}`}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name="dataAnuncio"
                label="Data de Anúncio "
                className="formItems"
              >
                <DatePicker format="DD/MM/YYYY" placeholder="Data de Anúncio" />
              </Form.Item>
              <Form.Item
                name="dataInativacaoAnuncio"
                label="Data de Inativação "
                className="formItems"
              >
                <DatePicker
                  format="DD/MM/YYYY"
                  placeholder="Data de Inativação"
                />
              </Form.Item>
            </Form>
          </>
        )}
      </Modal>
    </>
  );
}
